export default "__VITE_ASSET__C5u45Vx2__"